export enum ActionTypes {
  SET_USER_INVITES_DATA = '@join/SET_USER_INVITES_DATA',
}
